import { isRunningPickAvailable, cashinOfferByTicketId$$ } from '../../turboLive/components/cashin/subs';
import { newTransactionStarted$, cashinIsLoading$, cashinOddsChosenPicks$, cashinOfferCurrent$ } from '../subs';
import { CashinOfferStatus, PickState } from '../constants';
import { useReframe } from 'nike-re-framejs';

export const useCashinButton = ticketId => {
    const { subscribe } = useReframe();
    const cashinOffer = subscribe(cashinOfferByTicketId$$(ticketId));
    const currentOpened = subscribe(cashinOfferCurrent$());
    return {
        hidden:
            !cashinOffer ||
            cashinOffer.status === CashinOfferStatus.Finished ||
            cashinOffer.status === CashinOfferStatus.NotAvailable,
        disabled: cashinOffer?.status === CashinOfferStatus.InProgress || currentOpened,
        autoCashinDisabled: !cashinOffer || !cashinOffer.automaticTransactionAllowed,
        cashinOffer
    };
};

// button na uzatvorenie
export const useCashinClosing = (ticketId: String, isCashinDisabled: boolean) => {
    const { subscribe } = useReframe();
    const cashinClosingBetIds = subscribe(cashinOddsChosenPicks$(ticketId));
    const cashinIsLoading = subscribe(cashinIsLoading$(ticketId));
    const newTransactionStarted = subscribe(newTransactionStarted$);
    return {
        isCashinClosingDisabled:
            (cashinClosingBetIds ? cashinClosingBetIds.length === 0 || cashinIsLoading : true) ||
            (isCashinDisabled && !newTransactionStarted),
        cashinClosingBetIds,
        newTransactionStarted
    };
};

// na vstup do uzt
export const useCashinClosingButton = ticketId => {
    const { subscribe } = useReframe();
    const cashinOffer = subscribe(cashinOfferByTicketId$$(ticketId));
    return {
        hidden: !isRunningPickAvailable(cashinOffer?.picks)
    };
};

export const useCashinClosingPickRows = pickState => {
    return {
        hidden: pickState === PickState.FINISHED,
        disabled: pickState === PickState.UNAVAILABLE || pickState === PickState.TRANSACTION_ACTIVE
    };
};
